import React from 'react';
import XMLViewer from 'react-xml-viewer';
import ReactJson from 'react-json-view';

const tryParseJson = (value) => {
    if (value == null) return null;
    if (typeof value === 'object') return value;
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (!trimmed) return null;
    if (trimmed[0] !== '{' && trimmed[0] !== '[') return null;
    try {
        return JSON.parse(trimmed);
    } catch (e) {
        return null;
    }
};

const isXml = (value) => {
    if (typeof value !== 'string') return false;
    const trimmed = value.trim();
    return trimmed.startsWith('<');
};

// react-xml-viewer butuh 1 root element. Payload TPS (<HEADER>...</HEADER><DETIL>...</DETIL>) punya 2 root -> bungkus <DATA>.
const normalizeXml = (value) => {
    let trimmed = value.trim().replace(/^\s*<\?xml[^?]*\?>\s*/, '');
    if (!trimmed.startsWith('<')) return trimmed;
    const open = trimmed.match(/^<([A-Za-z_][\w:.-]*)\b[^>]*?(\/?)>/);
    if (!open) return trimmed;
    const tag = open[1];
    if (open[2] === '/') {
        if (trimmed.slice(open[0].length).trim()) return `<DATA>${trimmed}</DATA>`;
        return trimmed;
    }
    const re = new RegExp(`<(/?)${tag}\\b[^>]*?>`, 'g');
    let depth = 0, end = -1, m;
    while ((m = re.exec(trimmed))) {
        if (/\/>$/.test(m[0])) continue;
        if (m[1] !== '/') depth++;
        else if (--depth === 0) { end = m.index + m[0].length; break; }
    }
    if (end === -1) return trimmed;
    if (trimmed.slice(end).trim()) return `<DATA>${trimmed}</DATA>`;
    return trimmed;
};

const PayloadViewer = ({ value }) => {
    if (value == null || (typeof value === 'string' && !value.trim())) {
        return <span>-</span>;
    }

    const json = tryParseJson(value);
    if (json !== null) {
        return (
            <ReactJson
                src={json}
                collapsed={false}
                enableClipboard
                displayDataTypes={false}
                displayObjectSize={false}
                style={{ fontSize: 12 }}
            />
        );
    }

    if (isXml(value)) {
        return (
            <div style={{ fontSize: 12 }}>
                <XMLViewer xml={normalizeXml(value)} />
            </div>
        );
    }

    return <pre style={{ margin: 0, fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{String(value)}</pre>;
};

export default ({ data }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', padding: 32 }}>
            <p variant="h6">Request</p>
            <div style={{ display: 'flex', padding: 16, flexDirection: 'column', width: '80vw', overflow: 'scroll', border: 'solid 1px #efefef', marginBlock: 16 }}>
                <PayloadViewer value={data?.request} />
            </div>
            <p variant="h6">Response</p>
            <div style={{ display: 'flex', padding: 16, flexDirection: 'column', width: '80vw', overflow: 'scroll', border: 'solid 1px #efefef', marginBlock: 16 }}>
                <PayloadViewer value={data?.response} />
            </div>
        </div>
    )
}